import React from 'react';

import { graphql } from 'gatsby';

import Layout from 'components/layout/Layout';
import Section from 'components/section/Section';

const CategoryTemplate = ({
  pageContext: { name, slug },
  data: {
    allSanityTool: { nodes: tools },
  },
  location,
}) => (
  <Layout header sidebar>
    <Section
      path="/category"
      slug={slug}
      name={name}
      tools={tools}
      prevPath={location.state?.prevPath}
    />
  </Layout>
);

export default CategoryTemplate;

export const query = graphql`
  query getCategoryTools($slug: String) {
    allSanityTool(filter: { categories: { elemMatch: { slug: { current: { eq: $slug } } } } }) {
      nodes {
        slug {
          current
        }
        name
        logo {
          asset {
            url
          }
        }
        description
      }
    }
  }
`;
